import request, { Methods, withToken, RequestType } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const POST_FILES_DELIVERY_POINT_RESET = 'POST_FILES_DELIVERY_POINT_RESET';
export const POST_FILES_DELIVERY_POINT_LOADING = 'POST_FILES_DELIVERY_POINT_LOADING';
export const POST_FILES_DELIVERY_POINT_SUCCESS = 'POST_FILES_DELIVERY_POINT_SUCCESS';
export const POST_FILES_DELIVERY_POINT_REJECT = 'POST_FILES_DELIVERY_POINT_REJECT';

//* ACTIONS ------------------------------------------------
export const postFilesDeliveryPointReset = () => ({ type: POST_FILES_DELIVERY_POINT_RESET });
export const postFilesDeliveryPointLoading = () => ({ type: POST_FILES_DELIVERY_POINT_LOADING });
export const postFilesDeliveryPointSuccess = (payload) => ({ type: POST_FILES_DELIVERY_POINT_SUCCESS, payload });
export const postFilesDeliveryPointReject = (payload) => ({ type: POST_FILES_DELIVERY_POINT_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const postFilesDeliveryPointRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.POST,
        headers: RequestType.Multipart,
        data,
    }, getState);

    return request(`/api/Route/AddRouteUploadFile`, options);
};


